import { reflectKeys } from "@utils/key.reflactor";

export const AWARD_RECIPIENT_SUBPAGE_TABS = reflectKeys(["STUDENTS", "TEACHERS"]);

export const DIGITAL_BADGE_SOURCE_TYPE = {
  LESSON: "LESSON",
  STANDALONE: "STANDALONE",
};

export const DIGITAL_BADGE_GAME_AWARD_TYPE = {
  DIGITAL_BADGE: "DIGITAL_BADGE",
};

export const DIGITAL_BADGE_AWARD_METHOD = {
  GAMIFICATION: "GAMIFICATION",
  MANUAL: "MANUAL",
} as const;

export const RESOURCE_STATUS = reflectKeys([
  "APPROVED",
  "DRAFT",
  "REJECTED",
  "PENDING_APPROVAL",
  "UNPUBLISHED",
  "ARCHIVED",
]);

export const DIGITAL_BADGE_STATUS_LABEL_KEYS: Record<string, string> = {
  [RESOURCE_STATUS.APPROVED]: "digital_badge_view_status_approved",
  [RESOURCE_STATUS.DRAFT]: "digital_badge_view_status_draft",
  [RESOURCE_STATUS.REJECTED]: "digital_badge_view_status_rejected",
  [RESOURCE_STATUS.PENDING_APPROVAL]: "digital_badge_view_status_pending_approval",
  [RESOURCE_STATUS.UNPUBLISHED]: "digital_badge_view_status_unpublished",
  [RESOURCE_STATUS.ARCHIVED]: "digital_badge_view_status_archived",
};
